window.onload = function(){
 var linkmsg=document.getElementById("linkmsg");
 linkmsg.style.visibility="visible";
 linkmsg.innerHTML="カラーを選択してください";
 document.getElementById("opmsg").innerHTML = "<p> </p>";
    opmsg.style.visibility="hidden";
}
//脚本数画像変更
function changeImg(){
showimg1();
var intD=document.getElementById("depth").value
var intW=document.getElementById("haba").value
var intH=document.getElementById("height").value
if (intH=="CT"){
 switch(true){
  case (intD<=60&&intW>=200):
   showimg3();
   break;
  case (intD>60&&intW>=161):
   showimg3();
   break;
   }
}else if (!intD=="CT"){
  showimg1();
}
}
function showimg1(){
document.area1.src = "https://cdn.shopify.com/s/files/1/0549/1834/8887/files/glande2_size.png?v=1643521741";
document.getElementById("opmsg").innerHTML = "<p> </p>";
opmsg.style.visibility="hidden";
}
function showimg3(){
document.area1.src = "https://cdn.shopify.com/s/files/1/0549/1834/8887/files/glande3_size.png?v=1643521906";
document.getElementById("opmsg").innerHTML = "<p>※脚3本となります。</p>";
opmsg.style.visibility="visible";
}
// カラー
function checkBtn(){
	
 var idColor = document.getElementsByName( "colortype" ) ;
 var strColor = "";
 var i=0;
 for ( strColor="", i=idColor.length; i--; ) {
  if ( idColor[i].checked ) {
   strColor = idColor[i];
   break ;
  }
 }
 document.getElementById("price").value=""
 cart_price.innerHTML =""+" 円";
 cart_haba.innerHTML="";
 cart_depth.innerHTML="";
 cart_height.innerHTML="";
 cart_color.innerHTML="";
 cart_option.innerHTML="";

 var linkmsg=document.getElementById("linkmsg");
 var strErrmsg="";
 if(strColor=""){
  linkmsg.style.visibility="visible";
  strErrmsg="カラーを選択してください";
  document.getElementById("price").value=""
  document.frm_detail.checkbtn.disabled =true;
 }else{
  linkmsg.style.visibility="hidden";
  linkmsg.innerHTML="";
  document.getElementById("price").value=""
  document.frm_detail.checkbtn.disabled =false;
 }
 if(strErrmsg!=""){
 linkmsg.innerHTML=strErrmsg;
    }
}
//天板
function checkOption(){
 document.getElementById("price").value=""
 cart_price.innerHTML =""+" 円";
 cart_haba.innerHTML="";
 cart_depth.innerHTML="";
 cart_height.innerHTML="";
 cart_color.innerHTML="";
 cart_option.innerHTML="";
 linkmsg.style.visibility="hidden"; //190208追加
	
var idOption = document.getElementsByName( "option" ) ;
var strOption = "";
var c=0;
for ( strOption="", c=idOption.length; c--; ) {
 if ( idOption[c].checked ) {
  strOption = idOption[c].id ;
  break ;
 }
}

	if(strOption =="rs"){
		msg1();
	}else{
		msg2();
	}
	
function msg1(){
document.getElementById("sizemsg").innerHTML = "<p>(高さ4種・横幅120～240cm・奥行50～90cmまで1cm単位でオーダー可能です。)</p>";
}
function msg2(){
document.getElementById("sizemsg").innerHTML = "<p>(高さ4種・横幅80～240cm・奥行50～90cmまで1cm単位でオーダー可能です。)</p>";
}
}
const strLink1="<a href=\"https://arneinteior.myshopify.com/products/"
const strLink2="\" target=\"_top\">→こちらのページよりお買い求めください。</a>"

function setGoods(url,haba,depth,height,board,leg){
this.url=url;this.haba=haba;this.depth=depth;this.hegith=height;this.board=board;this.leg=leg;}
function searchURL(strHaba,strDepth,strHeight,strOption){
var strErr;
var intDepth=document.getElementById("depth").value
var intHaba=document.getElementById("haba").value
intDepth=parseInt(intDepth);
intHaba=parseInt(intHaba);
//幅チェック
if(strOption =="rs"){
	if (intHaba < 120){
 	strErr="幅120cm未満";
	}else if (intHaba > 240){
		strErr="幅240cm以上";
	}
}else{
	if (intHaba < 80){
		strErr="幅80cm未満";
	}else if (intHaba > 240){
		strErr="幅240cm以上";
	}
}
//奥行チェック
if (intDepth < 50){
 strErr="奥行50cm未満";
}else if (intDepth > 90){
  strErr="奥行90cm以上";
}
if(strErr){document.getElementById("price").value="";
return strErr+"はオーダー不可です。";}
//幅サイズ成形
switch(strHaba.length){
 case 2:
  if(strHaba.slice(0,1)=="9" && strHaba.slice(-1)!="0"){
   strHaba ="100";
  }else if(strHaba.slice(-1) !="0"){
   strHaba=parseInt(strHaba.slice(0,1))+1+"0";
  }else{
   
  }
  break;
 case 3:
  if(strHaba.slice(-1)=="0"){
   
  }else{
   if(strHaba.slice(1,2)=="9" && strHaba.slice(-1)!="0"){
    strHaba="200";
   }else{
    strHaba=strHaba.slice(0,1)+parseInt(parseInt(strHaba.slice(1,2))+1)+"0";
   }
  }
  break;
} 
//奥行サイズ成型
switch(strDepth.length){
 case 2:
  if(strDepth.slice(0,1)=="9" && strDepth.slice(-1)!="0"){
   strDepth ="100";
  }else if(strDepth.slice(-1) !="0"){
   strDepth=parseInt(strDepth.slice(0,1))+1+"0";
  }else{
   
  }
  break;
 case 3:
  if(strDepth.slice(-1)=="0"){
   
  }else{
  strDepth=strDepth.slice(0,1)+parseInt(parseInt(strDepth.slice(1,2))+1)+"0";
  }
  break;
}
 
//ベース価格
var basePrice = [112000,123000,156000];
var basePriceCt = [122000,133000,166000];
var addPriceWidth = [1000,7000,12000];
var addPriceDepth = [2000];
var mulHaba1;
var mulDepth;
var mulHaba2;
var mulHaba3;
var calMul;
var sellPrice;
var i=0;
 strHaba=parseInt(strHaba);
 strDepth=parseInt(strDepth);
 mulDepth=(strDepth-50)/10; 
 mulHaba1=(strHaba-80)/10;
 mulHaba2=(strHaba-130)/10;
 mulHaba3=(strHaba-170)/10; 
  if(strHeight!="CT"){
   switch(true){
    case strHaba<130:
     if(strHaba > strDepth){
      sellPrice = basePrice[i]+(addPriceWidth[i]*mulHaba1)+(addPriceDepth[i]*mulDepth);
     }else if(strHaba <= strDepth){
      sellPrice = basePrice[i]+(addPriceWidth[i]*mulDepth)+(addPriceDepth[i]*mulHaba1);
     }
     break;
    case strHaba>=130&&strHaba<170:     
     sellPrice = basePrice[i+1]+(addPriceDepth[i]*mulDepth)+(addPriceWidth[i+1]*mulHaba2);
     break;
    case strHaba>=170:
     sellPrice = basePrice[i+2]+(addPriceDepth[i]*mulDepth)+(addPriceWidth[i+2]*mulHaba3);
     break;
     }
  }else {
   switch(true){
    case strHaba<130:
     sellPrice = basePriceCt[i]+(addPriceWidth[i]*mulHaba1)+(addPriceDepth[i]*mulDepth);
     break;
    case strHaba>=130&&strHaba<170:     
     sellPrice = basePriceCt[i+1]+(addPriceDepth[i]*mulDepth)+(addPriceWidth[i+1]*mulHaba2);
     break;
    case strHaba>=170:
     sellPrice = basePriceCt[i+2]+(addPriceDepth[i]*mulDepth)+(addPriceWidth[i+2]*mulHaba3);
     break;
     }
   }
var idColor = document.getElementsByName( "colortype" ) ;
var i=0;
var strColor = "";   
for ( strColor="", i=idColor.length; i--; ) {
 if ( idColor[i].checked ) {
  strColor = idColor[i].id;
  break ;
 }
}
 var existingprice=checkPrice(strHaba,strDepth,strHeight,strOption);
 if (strColor=="tg"||strColor=="tb"){//2019-2-25追加
 existingprice="";
 } 
 if(!existingprice == ""){
 existingprice=parseInt(existingprice);
  if(strOption!="sq"){
   if(strColor == "tg"||strColor=="tb"){
    sellPrice=Math.ceil((sellPrice*1.1/1000))*1000;//10%UPの1000円単位切上
   }
   sellPrice = sellPrice+6000;   
   return sellPrice;
  }else if(strOption=="sq"){
   sellPrice = existingprice;
   if(strColor == "tg"||strColor=="tb"){
    sellPrice=Math.ceil((sellPrice*1.1/1000))*1000;//10%UPの1000円単位切上
   }   
   return sellPrice;
  }
 }else if(existingprice == ""){
  if(strOption!="sq"){
   if(strColor == "tg"||strColor=="tb"){
    sellPrice=Math.ceil((sellPrice*1.1/1000))*1000;//10%UPの1000円単位切上
   }
   sellPrice = sellPrice+6000;
   return sellPrice;
  }else if(strOption=="sq"){
   if(strColor == "tg"||strColor=="tb"){
    sellPrice=Math.ceil((sellPrice*1.1/1000))*1000;//10%UPの1000円単位切上
   }  
   return sellPrice;
  }
 }
}
/*リストから商品URLを取得*/
function checkURL(strHaba,strDepth,strHeight,strOption){
  for(var i in goods){
if(goods[i].haba==strHaba && goods[i].depth==strDepth && goods[i].board==strOption && goods[i].leg==strHeight){
return goods[i].url;}}
return false;
}
/*リストから価格を取得*/
function checkPrice(strHaba,strDepth,strHeight,strOption){
  for(var i in goods){
if(goods[i].haba==strHaba && goods[i].depth==strDepth && goods[i].board==strOption && goods[i].leg==strHeight){
return false;}}
return false;
}
// 数値チェック
function isNumber(numVal){
  var pattern =/^([1-9]\d*|0)$/;
  return pattern.test(numVal);
}
/*価格算出ボタン押下時*/
function jump(){
 document.getElementById("price").value =""+" 円";
 cart_price.innerHTML =""+" 円";
 cart_haba.innerHTML="";
 cart_depth.innerHTML="";
 cart_height.innerHTML="";
 cart_color.innerHTML="";
 cart_option.innerHTML="";
 
var linkmsg=document.getElementById("linkmsg");
linkmsg.innerHTML="";
linkmsg.style.visibility="hidden";
var ErrMsg=document.getElementById("linkmsg");
ErrMsg.innerHTML="";
document.getElementById("price").value=""

var strDepth=document.getElementById("depth").value;
var strHaba=document.getElementById("haba").value;
var strHeight=document.getElementById("height").value;
var idColor = document.getElementsByName( "colortype" ) ;
var idOption = document.getElementsByName( "option" ) ;
var strColor = "";
var strOption = "";
var i=0;
var c=0;
for ( strColor="", i=idColor.length; i--; ) {
 if ( idColor[i].checked ) {
  strColor = idColor[i].id;
  var valueColor = idColor[i].value ;
  break ;
 }
}
for ( strOption="", c=idOption.length; c--; ) {
 if ( idOption[c].checked ) {
  strOption = idOption[c].id ;
  var valueOption = idOption[c].value ;
  break ;
 }
}
if(strHeight=="height-select"){
alert("高さを選択してください");
return false;
}
var strLeg;//2019-2-25
switch(true){
 case strHeight=="LT":
  strLeg="40.5";
  break;
 case strHeight=="HT":
  strLeg="55.5";
  break;
 case strHeight=="DT":
  strLeg="72";
  break;
 case strHeight=="CT":
  strLeg="90";
  break;  
}
if (isNumber(strHaba)==false){
alert("幅は『1以上の整数(小数点不可/半角文字）』をご入力ください。");
return false;
}else if(isNumber(strDepth)==false){
alert("奥行は『1以上の整数(小数点不可/半角文字）』をご入力ください。");
return false;
}
document.getElementById("choice1").value=strHaba+"cm"
document.getElementById("choice2").value=strDepth+"cm"
document.getElementById("choice3").value=strLeg+"cm"//2019-2-25
document.getElementById("choice4").value=valueColor
document.getElementById("choice5").value=valueOption

//商品ページの有無チェック
var comcode=checkURL(strHaba,strDepth,strHeight,strOption);
if (strColor=="tg"||strColor=="tb"){//2019-2-25
comcode="";
}
if (!comcode==""){
var target=document.getElementById("linkmsg");
linkmsg.style.visibility="visible";
target.innerHTML="ご希望サイズは既製品がございます。<br>"+strLink1+comcode+"/"+strLink2;
return false;
}
var url=searchURL(strHaba,strDepth,strHeight,strOption);

if(!url){
alert("幅を入力してください");
return false;
}

var intUnit
if (isNaN(url)==false){
 intUnit=parseInt(url)/1000;
 document.getElementById("price").value =parseInt(url).toLocaleString()+" 円";
 cart_price.innerHTML =parseInt(url).toLocaleString()+" 円";
 cart_haba.innerHTML=strHaba;
 cart_depth.innerHTML=strDepth;
 cart_height.innerHTML=strLeg;//2019-2-25
 cart_color.innerHTML=valueColor;
 cart_option.innerHTML=valueOption;
}
else if(isNaN(url)==true) {
linkmsg.style.visibility="visible";
 ErrMsg.innerHTML=url;
 intUnit=""
}
document.getElementById("units").value=intUnit;
document.getElementById("choice6").value="見積もり金額："+url;
return false;
}
function checkText() {
 var choice1=document.frm.choice1.value;
 var choice2=document.frm.choice2.value;
 var choice3=document.frm.choice3.value;
    var text = document.frm.inventory_id.value;
    var price = document.frm_detail.price.value;
    if(choice1=="" || choice2=="" || choice3=="") {
        alert("ご希望のサイズを正しく入力後、価格算出ボタンを押してください。");
        return false;
        }           

    if(price=="") {
        alert("価格が算出されていません。既製品がある場合、「この条件で金額算出」ボタン下の該当商品ページよりお買い求めください。");
        return false;
        }       
     return true;
}
goods = new Object();
goods[0] =new setGoods("0000a08807","80","80","41","sq","LT");
goods[1] =new setGoods("0000a08810","120","80","41","sq","LT");
goods[2] =new setGoods("0000a08813","160","80","41","sq","LT");
goods[3] =new setGoods("0000a08816","200","80","41","sq","LT");
goods[4] =new setGoods("0000a08819","240","80","41","sq","LT");
goods[5] =new setGoods("0000a09210","80","80","56","sq","HT");
goods[6] =new setGoods("0000a09213","120","80","56","sq","HT");
goods[7] =new setGoods("0000a09216","160","80","56","sq","HT");
goods[8] =new setGoods("0000a09219","200","80","56","sq","HT");
goods[9] =new setGoods("0000a09222","240","80","56","sq","HT");
goods[10] =new setGoods("0000a09225","80","80","72","sq","DT");
goods[11] =new setGoods("0000a09228","120","80","72","sq","DT");
goods[12] =new setGoods("0000a09231","160","80","72","sq","DT");
goods[13] =new setGoods("0000a09234","200","80","72","sq","DT");
goods[14] =new setGoods("0000a09237","240","80","72","sq","DT");
goods[15] =new setGoods("0000a12138","120","80","41","rs","LT");
goods[16] =new setGoods("0000a12141","160","80","41","rs","LT");
goods[17] =new setGoods("0000a12144","200","80","41","rs","LT");
goods[18] =new setGoods("0000a12147","240","80","41","rs","LT");
goods[19] =new setGoods("0000a12150","120","80","56","rs","HT");
goods[20] =new setGoods("0000a12153","160","80","56","rs","HT");
goods[21] =new setGoods("0000a12156","200","80","56","rs","HT");
goods[22] =new setGoods("0000a12159","240","80","56","rs","HT");
goods[23] =new setGoods("0000a12162","120","80","72","rs","DT");
goods[24] =new setGoods("0000a12165","160","80","72","rs","DT");
goods[25] =new setGoods("0000a12168","200","80","72","rs","DT");
goods[26] =new setGoods("0000a12171","240","80","72","rs","DT");
goods[27] =new setGoods("0000a12174","80","80","41","rw","LT");
goods[28] =new setGoods("0000a12177","120","80","41","rw","LT");
goods[29] =new setGoods("0000a12180","160","80","41","rw","LT");
goods[30] =new setGoods("0000a12183","200","80","41","rw","LT");
goods[31] =new setGoods("0000a12186","240","80","41","rw","LT");
goods[32] =new setGoods("0000a12189","80","80","56","rw","HT");
goods[33] =new setGoods("0000a12192","120","80","56","rw","HT");
goods[34] =new setGoods("0000a12195","160","80","56","rw","HT");
goods[35] =new setGoods("0000a12198","200","80","56","rw","HT");
goods[36] =new setGoods("0000a12201","240","80","56","rw","HT");
goods[37] =new setGoods("0000a12204","80","80","72","rw","DT");
goods[38] =new setGoods("0000a12207","120","80","72","rw","DT");
goods[39] =new setGoods("0000a12210","160","80","72","rw","DT");
goods[40] =new setGoods("0000a12213","200","80","72","rw","DT");
goods[41] =new setGoods("0000a12216","240","80","72","rw","DT");
goods[42] =new setGoods("0000a13754","80","50","90","sq","CT");
goods[43] =new setGoods("0000a14586","120","50","90","sq","CT");
goods[44] =new setGoods("0000a14589","160","50","90","sq","CT");
goods[45] =new setGoods("0000a14592","200","50","90","sq","CT");
goods[46] =new setGoods("0000a14595","240","50","90","sq","CT");


